import { endpoints } from '../api/sharedEndpoints';
import type {
  AdminSetRoleResponse,
  AdminUsersListResponse,
  Role,
} from '../api/types';

export interface AdminRepository {
  listUsers(params: {
    query?: string;
    limit?: number;
    offset?: number;
  }): Promise<AdminUsersListResponse>;

  setUserRole(params: {
    telegramId: string;
    role: Role;
  }): Promise<AdminSetRoleResponse>;
}

export class ApiAdminRepository implements AdminRepository {
  async listUsers(params: {
    query?: string;
    limit?: number;
    offset?: number;
  }): Promise<AdminUsersListResponse> {
    return endpoints.adminListUsers({
      query: params.query,
      limit: params.limit,
      offset: params.offset,
    });
  }

  async setUserRole(params: {
    telegramId: string;
    role: Role;
  }): Promise<AdminSetRoleResponse> {
    return endpoints.adminSetUserRole(params.telegramId, { role: params.role });
  }
}
